import { Box, CircularProgress, Stack, Typography } from "@mui/joy";
import { ModalBackdrop } from "@mui/joy/Modal/Modal";
import axios from "axios";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import React from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router";
import { collectionData } from "rxfire/firestore";
import { auth, db, onAuthStateChanged, signOut } from "../config/firebase";
import { getNotification, getUserInfo, toCoinAmount } from "../config/services";
import {
  notification$,
  notificationall$,
  userinfo$,
  walletData$,
  walletInfos$,
} from "../redux/action";
import { Helmet } from "react-helmet";
import { logOut } from "./profile";

export function DashboardIndex() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);

  const dispatch = useDispatch();
  let totalbalance = [];

  React.useEffect(() => {
    // setLoading(true);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        //get notifications
        getNotification(user.uid);
        //get user infos
        getUserInfo(user.uid).subscribe((userData) => {
          const {
            btc_balance,
            bnb_balance,
            tron_balance,

            sol_balance,
            avax_balance,
            arb_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,

            usdtsol_balance,
            usdtavax_balance,
            usdtarb_balance,
            usdtbnb_balance,

            suspended,
          } = userData;

          const isSuspended = suspended === true;
          if (isSuspended) {
            signOut(auth)
              .then(() => {
                console.log("Suspended");
                navigate("/auth/login");
              })
              .catch((error) => {
                console.log(error);
              });
          }

          //totalbalance
          totalbalance = [
            btc_balance,
            bnb_balance,
            tron_balance,

            sol_balance,
            avax_balance,
            arb_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,

            usdtsol_balance,
            usdtavax_balance,
            usdtarb_balance,
            usdtbnb_balance,
          ].reduce((prv, cur) => {
            return prv + cur;
          }, 0);

          dispatch(
            userinfo$({
              ...userData,
              id: user.uid,
              totalBalance: totalbalance,
            }),
          );

          //get crypto info
          axios
            .get(
              `https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin%2Ctron%2Ctether%2Csolana%2Carbitrum%2Cbifrost-bridged-matic-bifrost%2Cavalanche-2&vs_currencies=usd&include_24hr_change=true`,
            )
            .then((res) => {
              const prices = res.data;
              var myArray = [
                  {
                    coinname: "BITCOIN",
                    cointype: "btc_balance",
                    price: prices.bitcoin.usd,
                    difference: prices.bitcoin.usd_24h_change,
                    balance: btc_balance,
                    balancecoin: toCoinAmount(btc_balance, prices.bitcoin.usd),
                    code: "BTC",
                    codeswap: "BTC",
                    image: "./images/coins/btc.png",
                    // address: btc,
                    network: "BTC",
                    thumbimage: "./images/coins/btc.png",
                    contractaddress: false,
                  },
                  {
                    coinname: "ETHERUEM",
                    cointype: "eth_balance",
                    price: prices.ethereum.usd,
                    difference: prices.ethereum.usd_24h_change,
                    balance: eth_balance,
                    balancecoin: toCoinAmount(eth_balance, prices.ethereum.usd),
                    code: "ETH",
                    codeswap: "ETH",
                    image: "./images/coins/eth.png",
                    // address: eth,
                    network: "ERC20",
                    thumbimage: "./images/coins/eth.png",
                    contractaddress: false,
                  },
                  {
                    coinname: "BNB SMART",
                    cointype: "bnb_balance",
                    price: prices.binancecoin.usd,
                    difference: prices.binancecoin.usd_24h_change,
                    balance: bnb_balance,
                    balancecoin: toCoinAmount(
                      bnb_balance,
                      prices.binancecoin.usd,
                    ),
                    code: "BNB",
                    codeswap: "BNB",
                    image: "./images/coins/bnb.png",
                    // address: bnb,
                    network: "BEP20",
                    thumbimage: "./images/coins/bnb.png",
                    contractaddress: false,
                  },

                  // For test purpose only

                  {
                    coinname: "SOLANA",
                    cointype: "sol_balance",
                    price: prices.solana.usd,
                    difference: prices.solana.usd_24h_change,
                    balance: sol_balance,
                    balancecoin: toCoinAmount(sol_balance, prices.solana.usd),
                    code: "SOL",
                    codeswap: "SOL",
                    image: "./images/coins/sol.png",
                    // address: eth,
                    network: "Solana",
                    thumbimage: "./images/coins/sol.png",
                    contractaddress: false,
                  },
                  {
                    coinname: "ARBITRUM",
                    cointype: "arb_balance",
                    price: prices.arbitrum.usd,
                    difference: prices.arbitrum.usd_24h_change,
                    balance: arb_balance,
                    balancecoin: toCoinAmount(arb_balance, prices.arbitrum.usd),
                    code: "ARB",
                    codeswap: "ARB",
                    image: "./images/coins/arb.png",
                    // address: eth,
                    network: "Arbitrum",
                    thumbimage: "./images/coins/arb.png",
                    contractaddress: false,
                  },

                  {
                    coinname: "AVALANCHE",
                    cointype: "avax_balance",
                    price: prices["avalanche-2"].usd,
                    difference: prices["avalanche-2"].usd_24h_change,
                    balance: avax_balance,
                    balancecoin: toCoinAmount(
                      avax_balance,
                      prices["avalanche-2"].usd,
                    ),
                    code: "AVAX",
                    codeswap: "AVAX",
                    image: "./images/coins/avax.png",
                    // address: eth,
                    network: "Avax",
                    thumbimage: "./images/coins/avax.png",
                    contractaddress: false,
                  },

                  {
                    coinname: "TRON",
                    cointype: "tron_balance",
                    price: prices.tron.usd,
                    difference: prices.tron.usd_24h_change,
                    balance: tron_balance,
                    balancecoin: toCoinAmount(tron_balance, prices.tron.usd),
                    code: "TRX",
                    codeswap: "TRX",
                    image: "./images/coins/tron.png",
                    // address: trx,
                    network: "TRC20",
                    thumbimage: "./images/coins/tron.png",
                    contractaddress: false,
                  },
                  {
                    coinname: "USDT",
                    cointype: "usdt_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdt_balance,
                    balancecoin: toCoinAmount(usdt_balance, prices.tether.usd),
                    code: "USDT TRC20",
                    codeswap: "USDT",
                    image: "./images/coins/usdt.png",
                    // address: trx,
                    network: "TRC20",
                    thumbimage: "./images/coins/tron.png",
                    contractaddress: true,
                  },
                  {
                    coinname: "USDT",
                    cointype: "usdterc20_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdterc20_balance,
                    balancecoin: toCoinAmount(
                      usdterc20_balance,
                      prices.tether.usd,
                    ),
                    code: "USDT ERC20",
                    codeswap: "USDT",
                    image: "./images/coins/usdt.png",
                    // address: eth,
                    network: "ERC20",
                    thumbimage: "./images/coins/eth.png",
                    contractaddress: true,
                  },

                  // for test purpose only
                  {
                    coinname: "USDT",
                    cointype: "usdtbnb_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdtbnb_balance,
                    balancecoin: toCoinAmount(usdtbnb_balance, prices.tether.usd),
                    code: "USDT BSC",
                    codeswap: "USDT",
                    image: "./images/coins/usdt.png",
                    // address: bnb,
                    network: "BEP20",
                    thumbimage: "./images/coins/bnb.png",
                    contractaddress: true,
                  },

                  {
                    coinname: "USDT",
                    cointype: "usdtsol_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdtsol_balance,
                    balancecoin: toCoinAmount(usdtsol_balance, prices.tether.usd),
                    code: "USDT SOL",
                    codeswap: "USDT",
                    image: "./images/coins/usdt.png",
                    // address: eth,
                    network: "Solana",
                    thumbimage: "./images/coins/sol.png",
                    contractaddress: true,
                  },
                  {
                    coinname: "USDT",
                    cointype: "usdtarb_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdtarb_balance,
                    balancecoin: toCoinAmount(usdtarb_balance, prices.tether.usd),
                    code: "USDT ARB",
                    codeswap: "USDT",
                    image: "./images/coins/usdt.png",
                    // address: eth,
                    network: "Arbitrum",
                    thumbimage: "./images/coins/arb.png",
                    contractaddress: true,
                  },
                  {
                    coinname: "USDT",
                    cointype: "usdtavax_balance",
                    price: prices.tether.usd,
                    difference: prices.tether.usd_24h_change,
                    balance: usdtavax_balance,
                    balancecoin: toCoinAmount(
                      usdtavax_balance,
                      prices.tether.usd,
                    ),
                    code: "USDT AVAX",
                    codeswap: "USDT",
                    image: "./images/coins/usdt.png",
                    // address: eth,
                    network: "Avax",
                    thumbimage: "./images/coins/avax.png",
                    contractaddress: true,
                  },
                ];
                myArray.sort((a, b) => b.balance - a.balance);
                dispatch(walletData$(myArray));
                setLoading(false);
            })
            .catch((error) => {
              console.log(error);
              setLoading(false);
            });
        });
        const usertransactionref = query(
          collection(db, "users", user.uid, "transactions"),
          // where("seen", "!=", true),
          orderBy("timestamp", "desc"),
        );
        const notifications = collectionData(usertransactionref).subscribe(
          (data) => {
            const getAllDocsWithoutField = (fieldName) => {
              const docsWithoutField = data.filter((doc) => {
                const data = doc;
                return !(fieldName in data);
              });

              return docsWithoutField;
            };
            dispatch(notificationall$(data.length));
            dispatch(notification$(getAllDocsWithoutField("seen").length));
          },
        );
        return () => {
          notifications.unsubscribe();
        };
      } else {
        navigate("/auth/login");
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <script src="https://widgets.coingecko.com/gecko-coin-price-marquee-widget.js"></script>
        <script src="//code.jivosite.com/widget/v4StzAf0Du" async></script>
      </Helmet>
      {loading ? (
        <ModalBackdrop
          sx={{
            flexDirection: "column",
            backgroundColor: (theme) => theme.palette.background.paper,
            zIndex: 1000,
          }}
        >
          <Box
            mt={1}
            display={"flex"}
            justifyContent={"center"}
            position={"relative"}
            top={"40%"}
          >
            <Stack spacing={1} alignItems={"center "}>
              <CircularProgress color="primary" />
              <Typography level="body-lg">Loading...</Typography>
            </Stack>
          </Box>
        </ModalBackdrop>
      ) : (
        <Outlet />
      )}
    </>
  );
}

/*
 <Helmet>
      <script src="//code.tidio.co/y4qvyvglyyragn1zlquny8um9fpsgoyg.js" async></script>
      </Helmet>

      <Backdrop open={loading}>
        <CustomCirleLoader />
      </Backdrop>
*/
